import React from 'react';
import { CheckIcon, GiftIcon, HeartIcon, LeafIcon, ShieldIcon, UtensilsIcon } from 'lucide-react';
import { Reveal } from './Reveal';
import { SectionHeading } from './SectionHeading';
import { CtaButton } from './CtaButton';
import { bonuses, checkoutUrl, images, mainBullets } from '../data/landing';
const bonusIcons = {
  spoon: UtensilsIcon,
  leaf: LeafIcon,
  heart: HeartIcon
};
export function ProductBonuses() {
  return <section className="bg-cream px-5 py-14 sm:py-20" data-id="element-53" data-mp="s30cbhs0yvbi">
      <Reveal data-id="element-54" data-mp="n3dx52smz502">
        <SectionHeading title="Todo lo que recibes hoy con El Escudo de Mamá" subtitle="Una guía principal + 3 bonos de regalo para ayudarte a empezar con más claridad, orden y confianza." data-id="element-55" data-mp="n3w1yntd6rjl" />
      </Reveal>

      <div className="mx-auto mt-10 max-w-5xl" data-id="element-56" data-mp="w3j0n1uplj8y">
        {/* Producto principal */}
        <Reveal data-id="element-57" data-mp="2chizsalqd4v5">
          <article className="overflow-hidden rounded-[28px] border border-gold/40 bg-white shadow-lift md:grid md:grid-cols-[0.9fr_1.1fr]" data-id="element-58" data-mp="2ch0wiu0nhqdq">
            <div className="relative bg-sage-light" data-id="element-59" data-mp="27l20qlczt63a">
              <img src={images.mainCover} alt="Guía principal El Escudo de Mamá" className="block aspect-square w-full object-cover" data-id="element-60" data-mp="1bizpbouk9e6r" />
              <span className="absolute left-4 top-4 inline-flex items-center gap-1.5 rounded-full bg-forest px-3 py-1.5 text-xs font-bold uppercase tracking-wide text-cream shadow-soft" data-id="element-61" data-mp="1fjtfkovh752t">
                <ShieldIcon className="h-3.5 w-3.5 text-gold-light" aria-hidden="true" data-id="element-62" data-mp="1pjaiwzn996vm" />
                Guía principal
              </span>
            </div>
            <div className="p-6 sm:p-8" data-id="element-63" data-mp="wulpznwcs7uy">
              <h3 className="font-serif text-3xl font-semibold text-forest" data-id="element-64" data-mp="wvohny1i2ebx">
                El Escudo de Mamá
              </h3>
              <p className="mt-3 leading-relaxed text-ink-muted" data-id="element-65" data-mp="11sew6gxnp1v8">
                Guía práctica y programa de 21 días para elevar las defensas de los
                niños desde la alimentación y los hábitos del hogar.
              </p>
              <ul className="mt-6 space-y-3" data-id="element-66" data-mp="e3vkrsjb88yx">
                {mainBullets.map(b => <li key={b} className="flex gap-3 text-[15px] leading-snug text-ink" data-id="element-67" data-mp="63xy4zc5fovy">
                    <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-forest" data-id="element-68" data-mp="61l8s142ac8v">
                      <CheckIcon className="h-3 w-3 text-cream" strokeWidth={3} aria-hidden="true" data-id="element-69" data-mp="fthfu1o4lcp8" />
                    </span>
                    {b}
                  </li>)}
              </ul>
            </div>
          </article>
        </Reveal>

        {/* Separador */}
        <Reveal data-id="element-70" data-mp="3jckb7ersp2e0">
          <div className="my-10 flex items-center gap-4" data-id="element-71" data-mp="3f8w38uz944s8">
            <div className="h-px flex-1 bg-gold/40" data-id="element-72" data-mp="3fagy6lph9pqm" />
            <p className="flex items-center gap-2 font-serif text-xl italic text-forest" data-id="element-73" data-mp="3t96sjtkwxbba">
              <GiftIcon className="h-5 w-5 text-gold-deep" strokeWidth={1.75} aria-hidden="true" data-id="element-74" data-mp="3o9u4j5ib1y74" />
              + 3 bonos de regalo
            </p>
            <div className="h-px flex-1 bg-gold/40" data-id="element-75" data-mp="18gv99psm7q4l" />
          </div>
        </Reveal>

        {/* Bonos */}
        <div className="grid gap-5 md:grid-cols-3" data-id="element-76" data-mp="13j3hcvrz040e">
          {bonuses.map((bonus, i) => {
          const Icon = bonusIcons[bonus.icon];
          return <Reveal key={bonus.number} delay={i * 0.06} className="h-full" data-id="element-77" data-mp="2qgkrydgdq57n" data-mpi={i}>
                <article className="flex h-full gap-4 rounded-3xl border border-sage-light bg-white p-4 shadow-soft md:flex-col md:p-5" data-id="element-78" data-mp="2cg9zx73c2kkw">
                  <div className="relative w-28 shrink-0 overflow-hidden rounded-2xl bg-sage-light md:w-full" data-id="element-79" data-mp="2held9rsu7d7v">
                    <img src={bonus.image} alt={`Mockup del bono ${bonus.title}`} className="block aspect-square w-full object-cover" data-id="element-80" data-mp="3568utj47lbxh" />
                  </div>
                  <div className="flex min-w-0 flex-1 flex-col" data-id="element-81" data-mp="2vfe6883hq08v">
                    <span className="inline-flex w-fit items-center gap-1 rounded-full bg-gold/15 px-2.5 py-1 text-[11px] font-bold uppercase tracking-wide text-gold-deep" data-id="element-82" data-mp="2vew4ivy26ttk">
                      <GiftIcon className="h-3 w-3" aria-hidden="true" data-id="element-83" data-mp="3o31ovhl7agsv" />
                      Bono de regalo {bonus.number}
                    </span>
                    <h3 className="mt-2 flex items-start gap-2 font-serif text-lg font-semibold leading-snug text-forest md:text-xl" data-id="element-84" data-mp="248peunobojdj">
                      <Icon className="mt-1 h-4 w-4 shrink-0 text-sage" strokeWidth={2} aria-hidden="true" data-id="element-85" data-mp="1z8kuuno7h6ik" />
                      {bonus.title}
                    </h3>
                    <p className="mt-1.5 text-sm leading-relaxed text-ink-muted" data-id="element-86" data-mp="1q97jfpgiu7v7">
                      {bonus.description}
                    </p>
                  </div>
                </article>
              </Reveal>;
        })}
        </div>

        <Reveal className="mt-10 text-center" data-id="element-87" data-mp="2iywl85122bxv">
          <CtaButton href={checkoutUrl} variant="forest" data-id="element-88" data-mp="2e6wt2yr88nbu">
            Quiero El Escudo de Mamá
          </CtaButton>
        </Reveal>
      </div>
    </section>;
}